import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { CheckboxContainer, Checked, Checkedbox, Label } from './component.styled';

const Checkbox = ({ value, disabled, updateProduct, prop, isList }) => {
  const [inputValue, setInputValue] = useState(value);

  useEffect(() => {
    setInputValue(value);
  }, [value]);

  const handleValueChange = () => {
    setInputValue(!inputValue);
    updateProduct(prop, !inputValue);
  };

  return (
    <CheckboxContainer isList={isList}>
      <Label>
        <Checked
          onChange={handleValueChange}
          checked={inputValue}
          disabled={disabled}
          value={inputValue}
          type="checkbox"
        />
        <Checkedbox />
      </Label>
    </CheckboxContainer>
  );
};

Checkbox.propTypes = {
  updateProduct: PropTypes.func.isRequired,
  prop: PropTypes.string.isRequired,
  value: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
  isList: PropTypes.bool,
};

Checkbox.defaultProps = {
  disabled: false,
  isList: false,
};

export default Checkbox;
